import { useDispatch, useSelector } from 'react-redux'
import Input from '../../../../../UI/Input/Input'
import { setLocal } from '../../../../../../redux/action/local'
import props from '../../../../../../redux/props'

const UsableArea = () => {
  const translations = useSelector((state) => state.translations)
  const purchaseProfile = useSelector((state) => state.PURCHASE_PROFILE)
  const dispatch = useDispatch()

  const update = (key) => (value) => {
    const updatePurchaseProfile = { ...purchaseProfile, usableArea: { ...purchaseProfile.usableArea, [key]: value } }
    // dispatch(setNewPurchaseProfile(updatePurchaseProfile))
    dispatch(setLocal(props.PURCHASE_PROFILE, updatePurchaseProfile))
  }

  return (
    <div className="wrapper">
      <div className="group">
        <div className="label">{translations['my-objects.pipeline.yield-and-object-criteria.usable-area.from']}</div>
        <div className="values">
          <Input
            type="number"
            suffix={translations['square-meter.symbol']}
            value={purchaseProfile.usableArea.from}
            onChange={update('from')}
            placeholder={translations['my-objects.pipeline.yield-and-object-criteria.usable-area.from']}
          />
        </div>
      </div>
      <div className="group">
        <div className="label">{translations['my-objects.pipeline.yield-and-object-criteria.usable-area.until']}</div>
        <div className="values">
          <div className="values">
            <Input
              type="number"
              suffix={translations['square-meter.symbol']}
              value={purchaseProfile.usableArea.until}
              onChange={update('until')}
              placeholder={translations['my-objects.pipeline.yield-and-object-criteria.usable-area.until']}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default UsableArea
